/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {NotificationVoModel} from '../models/notificationVo.model';
import {UserContext } from '@irian-ro/util-user';
import {StompService} from '@irian-ro/stomp-module';
import {EnvironmentService} from "@irian-ro/util-environment";
import {MessageService} from "primeng/api";

@Injectable()
export class NotificationEndpoint {
  subscription: any | undefined = undefined;
  hotNotification: ReplaySubject<NotificationVoModel[]> = new ReplaySubject();
  notificationsUrl = '/api/notifications';
  wsEndpoint = '/user/queue/notification';
  private connected = false;
  private initNotifications = true;

  constructor(private stompService: StompService,
              private userContext: UserContext,
              private httpClient: HttpClient,
              private messageService: MessageService,
              private environmentService: EnvironmentService) {

    if (this.environmentService && this.environmentService.getEnvironmentProperty('notificationsUrl')) {
      this.notificationsUrl = `${this.environmentService.getEnvironmentProperty('notificationsUrl')}`;
    }

    this.initNotifications = true;

    this.userContext.getCurrentUser().subscribe(
      (user: any) => {
        if (user.uuid) {
          if (this.connected === false) {
            this.stompService.register(this.addSubscription());
            this.stompService.register(this.sendMessage(user.name));
            this.connected = true;
          }
        } else {
          if (this.subscription && this.connected) {
            this.hotNotification.next([]);
            this.subscription.unsubscribe();
            this.connected = false;
            this.subscription = null;
            this.initNotifications = true;
          }
        }
      });
  }

  addSubscription() {
    return (stompClient: any) => {
      this.subscription = stompClient.subscribe(this.wsEndpoint, (notifications: any) => {
        const notificationData = JSON.parse(notifications.body);
        this.hotNotification.next(notificationData);
      });
    };
  }

  sendMessage(userName: string) {
    return (stompClient: any) => {
      stompClient.send('/app/initial', {}, userName);
    };
  }

  getHotNotification(): Observable<NotificationVoModel[]> {
    return this.hotNotification.asObservable();
  }

  markAsSeen(notificationUuids: string[]) {
    return this.httpClient.put(`${this.notificationsUrl}/markAsSeen`, notificationUuids);
  }

  remove(notificationUuids: string[]) {
    return this.httpClient.put(`${this.notificationsUrl}/remove`, notificationUuids);
  }

  pushToastNotifications(data: any){
    if(!this.initNotifications){
      data.forEach((notification: any) => {
        this.messageService.add({key: 'global-notification', severity:'info', summary: notification.subject, detail: notification.content});
      })
    }else{
      this.initNotifications = false;
    }
  }
}
